import { Device } from '@/models/device';
import apiClient from '@/api/client';

export const PartnerDeviceService = {
    async getAll(): Promise<PartnerDeviceResponse> {
        const response = await apiClient.get<PartnerDeviceResponse>('/partner/devices');
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to retrieve devices.');
        }

        return result;
      },

    async delete(id: string) {
        const response = await apiClient.delete(`/partner/devices/${id}`);
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to delete device.');
        }

        return result;
    },

    async update(id: string, serialNumber?: string, imei?: string, type?: string, phoneNumber?: string, simSerialNumber?: string, simProviderId?: string, subCustomFieldIds?: string[], firmware?: string, configurationId?: string) {
        const response = await apiClient.put(`/partner/devices/${id}`, {
            serialNumber: serialNumber,
            imei: imei,
            type: type,
            simSerialNumber: simSerialNumber,
            phoneNumber: phoneNumber,
            simProviderId: simProviderId,
            subCustomFieldIds: subCustomFieldIds,
            firmware: firmware,
            configurationId: configurationId
        });
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to update device.');
        }

        return result;
    },

    async bulkUpdate(ids: string[], type?: string, simProviderId?: string, subCustomFieldIds?: string[], firmware?: string, configurationId?: string) {
        const response = await apiClient.put('/partner/devices/bulk', {
            ids: ids,
            type: type,
            simProviderId: simProviderId,
            subCustomFieldIds: subCustomFieldIds,
            firmware: firmware,
            configurationId: configurationId
        });
        const result = response.data

        if (response.status != 200) {
            throw new Error('Failed to update devices.');
        }

        return result;
    }
}

export interface PartnerDeviceResponse {
    devices: Device[]
}
